import { props } from "../app/shared/project-config";
export const environment = {
  production: true,
  ...props['ezpin'],
  baseUrl: "https://api2.ezpaypin.com/api/v1",
  baseUrlTwo: "https://api2.ezpaypin.com/api/v2",
  // baseUrl: 'https://test.ezpaypin.com/api/v1',
  // baseUrl: 'https://api.mena.cards/api/v1',
  logBaseUrl: "https://log.ezpaypin.com/api/v1",
  // captchaCode: '6LeY9LUUAAAAAJQkUfAt30k5hnwr5BgP3VM575AR',
  // captchaCode: '6LeY9LUUAAAAAJQkUfAt30k5hnwr5BgP3VM575AR',
  captchaCode: "6Le-dMUjAAAAAPqaE7Yvipzv1NdRXIr9HVoTplUM",

  // captchaCode: '6LeO9LUUAAAAAB1FH_zLGM9fRIfceEfjqqgvsdz8',
  title: 'EZ Pin',
  sentryDSN:
    "https://0e896c9a3369410aa7a054272d083d72@o442018.ingest.sentry.io/5413033",
  sentrySampleRate: 0.333,
  gatewayReturnUrl: "https://panel.ezpaypin.com/online-payments/add",
  postpaidReturnUrl: "https://panel.ezpaypin.com/postpaid/list",
  bulkActivateAccessoryReturnUrl: "https://panel.ezpaypin.com/gifts/accessory",
  subscriptionGatewayReturnUrl:
    "https://panel.ezpaypin.com/gifts/accessory/orders",
  physicalOrderGatewayReturnUrl:
    "https://panel.ezpaypin.com/gifts/physical-orders",

  mediaUploadUrl: "https://api.ezpaypin.com/api/v1/notification-system/media/",
  version: "v3.14.0",
  projectUrl: "https://panel.ezpaypin.com",
  catalogLinkBaseUrl: "https://shop.ezpin.com/",
  card_status: {
    active: 1,
    pending: -1,
    deactive: 0,
    not_sp: -10,
    failed: -2,
  },

  card_types: {
    physical: 1,
    digital: 2,
    accessory: 3,
    preActivatedBundle: 4,
    whiteCard: 5,
  },

  role_types: {
    admin: 1,
    reseller: 2,
    seller: 3,
  },
};
